import React from 'react';
import _ from 'lodash';

export const checkHasChange = (oldValue, newValue) => {
    if ((oldValue === null && newValue === undefined) || 
        (oldValue === undefined && newValue === null) ||
        newValue === oldValue) {
        return false;
    }
    return true;
};

export const CheckDiffText = ({ oldValue, newValue }) => {
    if (checkHasChange(oldValue, newValue)) {
        return (
            <span className='dirty-text'>
                <span className='old'>{oldValue}</span>
                <span className='new'>{newValue}</span>
            </span>
        );
    }
    return <span>{oldValue}</span>;
};

export const hasChanges = (oldValues, newValues) => {
    if (oldValues === newValues) return false;

    const normalizedOld = oldValues || {};
    const normalizedNew = newValues || {};

    const cleanOld = Object.fromEntries(Object.entries(normalizedOld).filter(([_k, v]) => v !== undefined));
    const cleanNew = Object.fromEntries(Object.entries(normalizedNew).filter(([_k, v]) => v !== undefined));

    return !_.isEqual(cleanOld, cleanNew);
};

const hasChangesLiftsCranesDetails = (values) => {
    let hasChange = false;
    Object.values(values).forEach((value) => {
        value.details.forEach((detail) => {
            if (['change', 'new'].includes(detail.status)) hasChange = true;
        });
    });
    return hasChange;
};

export const hasChangesLiftsCranes = (oldValues, newValues) => {
    const normalizedOld = oldValues || {};
    const normalizedNew = newValues || {};
    
    if (hasChangesLiftsCranesDetails(normalizedNew)) return true;

    const compareRange = (oldRange, newRange) => {
        const oldClean = {
            checked: oldRange && oldRange.checked ? oldRange.checked : false,
            details: oldRange && oldRange.details ? oldRange.details.map(d => _.omit(d, ['status', '_id'])) : [],
        };
        const newClean = {
            checked: newRange && newRange.checked ? newRange.checked : false,
            details: newRange && newRange.details ? newRange.details.map(d => _.omit(d, ['status', '_id'])) : [],
        };
        return _.isEqual(oldClean, newClean);
    };

    const allKeys = new Set([...Object.keys(normalizedOld), ...Object.keys(normalizedNew)]);
    return Array.from(allKeys).some(key => !compareRange(normalizedOld[key], normalizedNew[key]));
};



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/common/utils.js